import { LoaderX } from "components/shared/Loader";
import React, { useState, FormEvent } from "react";
import { IoCloseOutline } from "react-icons/io5";
import HoneypotField from "components/shared/HoneypotField";
import useSpamGuard from "hooks/useSpamGuard";

const SUCCESS_MESSAGE =
  "Profile submitted successfully. We'll be in touch if there's a fit!";

interface JoinTeamModal {
  closer: () => void;
}
const JoinTeamModal = ({ closer }: JoinTeamModal) => {
  const [linkedInProfile, setLinkedInProfile] = useState("");
  const [success, setSuccess] = useState<String>("");
  const [error, setError] = useState<String>("");
  const [loading, setLoading] = useState<boolean>(false);
  // Shorter fill-time floor than the other forms: this is one field that a real
  // person will usually paste into rather than type.
  const { honeypotProps, isLikelyBot } = useSpamGuard(2000);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (linkedInProfile.trim() == "") {
      setError("Please enter your LinkedIn profile link.");
    } else if (isLikelyBot()) {
      // Drop silently and mirror the success path, so a bot gets no signal.
      setSuccess(SUCCESS_MESSAGE);
      setError("");
      setLinkedInProfile("");
      setTimeout(() => {
        closer();
      }, 3000);
    } else {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_IAM_URL}/inquiries/submit-profile`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              linkedInUrl: linkedInProfile,
            }),
          }
        );

        if (response.ok) {
          setSuccess(SUCCESS_MESSAGE);
          setError("");
          setLinkedInProfile("");
          setLoading(false);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setTimeout(() => {
          closer();
        }, 3000);
      }
    }
  };
  return (
    <div
      onClick={closer}
      className="fixed  w-screen z-[999] h-screen top-0 left-0 flex items-center justify-center bg-black bg-opacity-60"
    >
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
        className=" max-w-[500px] p-4 lg:p-6 rounded-xl bg-white w-4/5 md:w-2/3 lg:w-[500px] relative"
      >
        <HoneypotField {...honeypotProps} />

        <div className="flex items-center justify-center gap-4 flex-col">
          <div className="flex justify-end items-end w-full">
            <span className="cursor-pointer" onClick={closer}>
              <IoCloseOutline className="text-2xl" />
            </span>
          </div>

          <h2 className="font-semibold text-xl text-bblack-7">
            Thank you for your interest in our team.
          </h2>
          <p className="text-sm text-bblack-7">
            We’re always on the lookout for great talent like yours. While we’re
            not hiring at the moment, feel free to share your LinkedIn profile
            with us. If we find a good fit in the future, we’ll be sure to reach
            out.
          </p>
          <label
            className="text-blueShades-4 mt-2 font-Medium text-sm flex-1 flex flex-col w-full"
            htmlFor="linkedInProfile"
          >
            LinkedIn Profile Link
            <input
              className="w-full py-3 px-4 mt-1 h-9  outline-blueShades-4 border-pbg border  rounded-md bg-white text-bblack-0 placeholder:text-ashShade-16"
              type="text"
              name="firstName"
              placeholder="e.g linkedin.com/in/johndoe"
              value={linkedInProfile}
              onChange={(e) => setLinkedInProfile(e.target.value)}
            />
          </label>
          {error && <p className="text-red-500 text-sm">{error}</p>}
          {success && <div className=" text-bgreen-0 text-sm">{success}</div>}

          <div className="flex justify-end items-center gap-5 w-full md:flex-row flex-col ">
            <button
              className="bg-white text-blueShades-4 py-[10px] px-[18px] rounded-md font-Medium text-sm border border-ashShade-19"
              onClick={closer}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blueShades2-1 text-white py-[10px] px-[18px] text-sm rounded-md font-Medium"
            >
              {loading ? (
                <div className="flex items-center justify-center gap-2">
                  <p>Submit</p>
                  <LoaderX subClass={"!h-4 !w-4"} />
                </div>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default JoinTeamModal;
